<template>
  <div>
    <b-card>
      <h4>{{ $t('Criar Tabela DTC') }}</h4>
      <hr class="mb-2">
      
      <validation-observer ref="createDtcForm">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group :label="$t('Nome') + '*'" label-for="name">
                <validation-provider #default="{ errors }" name="name" rules="required">
                  <b-form-input
                    id="name"
                    v-model="tableData.name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('Nome da tabela')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group :label="$t('Descrição')" label-for="description">
                <validation-provider #default="{ errors }" name="description">
                  <b-form-input
                    id="description"
                    v-model="tableData.description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('Descrição opcional')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Ações -->
          <b-row class="mt-2">
            <b-col cols="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                :disabled="isSubmitting"
              >
                <b-spinner v-if="isSubmitting" small class="mr-50" />
                {{ $t('Salvar e Continuar') }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="$router.push({ name: 'dtc-list' })"
              >
                {{ $t('Cancelar') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BSpinner
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import dtcStoreModule from './dtcStoreModule'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tableData: {
        name: '',
        description: '',
        items: [],
        applications: []
      },
      isSubmitting: false,
      required
    }
  },
  setup() {
    const DTC_APP_STORE_MODULE_NAME = 'app-dtc'

    if (!store.hasModule(DTC_APP_STORE_MODULE_NAME)) {
      store.registerModule(DTC_APP_STORE_MODULE_NAME, dtcStoreModule)
    }

    return {}
  },
  methods: {
    onSubmit() {
      this.$refs.createDtcForm.validate().then(success => {
        if (success) {
          this.isSubmitting = true
          
          store.dispatch('app-dtc/addTable', this.tableData)
            .then(response => {
              const dtcTableId = response.data?.id || response.data
              
              // Verifica se veio de cobertura e tem um assetModelId
              const assetModelId = this.$route.query.assetModelId
              
              if (assetModelId && dtcTableId) {
                // Relaciona automaticamente
                return store.dispatch('app-dtc/linkModel', { dtcTableId, assetModelId })
                  .then(() => dtcTableId)
              }
              
              return dtcTableId
            })
            .then((dtcTableId) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Tabela criada.'),
                  text: this.$t('Importe os códigos ou vincule modelos.'),
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })

              this.$router.push({
                name: 'edit-dtc-table',
                params: { id: dtcTableId },
                query: { tab: 'items' }
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$t('Erro ao criar tabela'),
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            })
            .finally(() => {
              this.isSubmitting = false
            })
        }
      })
    },
  },
  destroyed() {
    // UnRegister on leave se achar necessário. Deixei para desregistrar apenas onde é necessário.
    // Opcional remover: store.unregisterModule('app-dtc')
  }
}
</script>

<style lang="scss" scoped>
</style>
